import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { alpha, Box, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

import { Text } from "../Text";

export interface InlineAlertProps {
  /**
   * The message to display in the alert
   */
  message: string;
  /**
   * Additional styles for the alert container
   */
  sx?: SxProps<Theme>;
}

const DANGER_BACKGROUND_OPACITY = 0.06;
const DANGER_BORDER_OPACITY = 0.2;

/**
 * Inline alert component for displaying error messages within dialogs and forms.
 * Follows the Berlin design system with danger styling.
 */
export function InlineAlert(props: InlineAlertProps) {
  const { message, sx } = props;

  return (
    <Box
      sx={mergeSxProps(
        (theme: Theme) => ({
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(3),
          padding: theme.spacing(4),
          borderRadius: theme.borderRadius?.xLarge,
          backgroundColor: alpha(theme.palette.base!.danger, DANGER_BACKGROUND_OPACITY),
          border: `1px solid ${alpha(theme.palette.base!.danger, DANGER_BORDER_OPACITY)}`,
        }),
        sx
      )}
    >
      <ErrorOutlineIcon
        sx={(theme: Theme) => ({
          color: theme.palette.base?.danger,
          fontSize: 18,
          flexShrink: 0,
        })}
      />
      <Text
        bold
        variant="body2"
        sx={(theme: Theme) => ({
          color: theme.palette.base?.danger,
        })}
      >
        {message}
      </Text>
    </Box>
  );
}
